
document.addEventListener('DOMContentLoaded', function () {
  const tagsToCheck = ["admin fee", "restockist"];
  console.log(window.customerTags);
  if (Array.isArray(window.customerTags)) {
    const hasBlockedTag = tagsToCheck.some(tag => window.customerTags.includes(tag));

   if (hasBlockedTag) {
      const buyNowButton = document.querySelector('shop-pay-wallet-button');
      if (buyNowButton) {
        buyNowButton.style.display = 'none';
        console.log("Buy Now button hidden due to restricted customer tag");
      }
    }
  }
});